module.exports = __webpack_public_path__ + "img/5C.bbf9c531.png";